import getStore from '../data/store/store';
import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
/**
 * Utility function to log the usage of options.
 */
export default function logDataOnSaveInvitations() {
    var currentState = getStore();
    if (!currentState) {
        return;
    }
    logDeleteForwardedEventsStatus();
    logDeleteUpdatedInvitationsStatus();
}
function logDeleteForwardedEventsStatus() {
    var currentState = getStore();
    if (currentState.removeForwardedMeetingNotifications != null) {
        var customData = datapoints.DeleteForwardedEventsNotificationOnOffStatus.datapoint.customData(currentState.removeForwardedMeetingNotifications);
        logUsage(datapoints.DeleteForwardedEventsNotificationOnOffStatus.datapoint.name, customData);
    }
}
function logDeleteUpdatedInvitationsStatus() {
    var currentState = getStore();
    if (currentState.removeOldMeetingMessages != null) {
        var customData = datapoints.DeleteUpdatedInvitationsOnOffStatus.datapoint.customData(currentState.removeOldMeetingMessages);
        logUsage(datapoints.DeleteUpdatedInvitationsOnOffStatus.datapoint.name, customData);
    }
}
//# sourceMappingURL=logDataOnSaveInvitations.js.map